module.exports = __webpack_public_path__ + "media/images/flags/spain-cf95c85ffbb49b9cb7441c22ab53edb8.jpg";